import windowLocation from 'fe-core/util/windowLocation';

export const getUrlParamValue = (parameter: string): string => {
  const queryString = windowLocation().search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(parameter) || '';
};
